import { JOB_BASE_URL } from "@/api/system/job";
import { FormDialog } from "@/component-create/FormDialog";
import { createFormItem } from "@/component-create/utils/create-form-item";
import { FORM_ITEM } from "@/components/form/enums";

import CronInput from './cron/input.vue'

export function renderJobEditForm(el: Element) {
  const ef = new FormDialog(
    el, 
    {
      items: formItems,
      elFormProps: {
        labelWidth: '100'
      },
      loadUrl: JOB_BASE_URL,
      saveUrl: JOB_BASE_URL,
      saveMethods: 'put'
    },
    '编辑'
  )
  return ef
}

const formItems = [
  [
    createFormItem('任务名称', 'jobName', FORM_ITEM.INPUT, { maxlength: '60', clearable: true }),
    createFormItem('任务分组', 'jobGroup', FORM_ITEM.SELECT, { dictCode: 'job_group', clearable: true }),
  ],
  [
    createFormItem('任务执行器', 'jobExecutor', FORM_ITEM.INPUT, { maxlength: '60', clearable: true }),
    createFormItem('执行表达式', 'scheduleExpression', CronInput),
  ],
  [
    createFormItem(
      '执行参数', 
      'executionParams', 
      FORM_ITEM.INPUT, 
      { 
        type: 'textarea', 
        row: 4, 
        maxlength: '200', 
        clearable: true, 
        showWordLimit: true 
      }
    )
  ],
  [
    createFormItem(
      '日志策略', 
      'logStrategy', 
      FORM_ITEM.SELECT, 
      { 
        loader: 'JOB_LOG_STRATEGY', 
      }
    ),
    createFormItem(
      '状态', 
      'status', 
      FORM_ITEM.SELECT, 
      { 
        loader: 'EOD', 
      }
    )
  ],
  [
    createFormItem('备注', 'remark', FORM_ITEM.INPUT, { type: 'textarea', rows: 3, maxlength: '200', showWordLimit: true }),
  ]
]